export default {
  placeholder: {
    reason_reject: 'Ablehnungsgrund eintragen',
    reason_route:
      'Abweichungsgrund eintragen: (z.B. Straße auf geplanter Route gesperrt, Privatanteil, ...)',
    reason_delete: 'Stornogrund eintragen',
  },
  route: {
    label: {
      name: 'Rayonname',
      number: 'Rayonnummer',
      total_distance: 'Plandistanz (km)',
      time_planned: 'Plandauer (h)',
    },
    placeholder: {
      name: 'Rayonname eingeben',
      number: 'Rayonnummer eingeben',
      total_distance: 'Plandistanz eingeben',
      time_planned: 'Plandauer eingeben',
    },
  },
  employee: {
    label: {
      employee: 'Mitarbeiter',
    },
    placeholder: {
      employee: 'Mitarbeiters eingeben',
      employee_single: 'Mitarbeiter eingeben',
    },
    all: 'Alle',
    active: 'Alle (active)'
  },
  filter_journeys_placeholder: 'Alle Aufzeichnungen',
  optional: 'optional',
}
